module.exports = __webpack_public_path__ + "img/presidentialsweet_room_feature01.b7f73c13.jpg";